module.exports = __webpack_public_path__ + "img/bg-skyv3@2x.e7ea793c.png";